// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__Eyrgk","content":"Consent_content__1JVaP","footer":"Consent_footer__1RtoZ"};